import React, { useEffect, useState } from "react";
import VirtualTable from "../ui/VirtualTable";
import { bm_date, drawPrice, moveItem } from "../utils/Utils";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
export default function POSSearchResults(props) {

    const { controller = "", route = "", type = "", results = {}, callback = () => { }, selected = {}, setSelected = () => { }, next = () => { }, prev = () => { }, align = () => { }, setAlign = () => { }, query = {}, setQuery = () => { } } = props;

    const { rows = [] } = results;


    const row_key = "posh_id";



    const columns = [

        {
            key: "date", title: <>InvDate</>, align: "left", width: 100, render: (e, f) => {
                return bm_date(f?.date);
            }
        },
        {
            key: "log_date", title: <>Log Date</>, align: "left", width: 100, render: (e, f) => {
                return bm_date(f?.log_date);
            }
        },
        {
            key: "latest_log", title: <>Status</>, align: "left", width: 100, render: (e) => {
                const parts = (e || "").split("│");
                return parts[0] || "";
            }
        },
        {
            key: "stage", title: <>Type</>, align: "left", width: 60
        },
        {
            key: "clerk_code", title: <>CL</>, align: "left", width: 40, render: (e, f) => {
                const parts = (f?.latest_log || "").split("│");
                return (parts[1])
            }
        },
        {
            key: "notes", title: <>Notes</>, align: "left", width: 100, grow: true, render: (e, f) => {
                const parts = (f?.latest_log || "").split("│");
                return (parts[2])

            }
        },
        {
            key: "customer", title: <>Customer</>, align: "left", width: 100, grow: true, render: (e, f) => {
                return f?.customer_ship_to?.name || ""
            }
        },
        {
            key: "invoice", title: <>Inv#</>, align: "left", width: 80
        },
        {
            key: "sale_net", title: <>Value</>, align: "right", width: 100, render: (e, f) => {
                return (e) ? e : "";
            }
        },



    ]

    // Customer, CustPo, Date (no filter), Invoice, ISBN

    const item_columns = [
        { key: "type", title: <>Type</>, align: "left", width: 80, render : (e, f) => {
            return(f?.header?.stage || "")
        }},
        { key: "invoice", title: <>Inv#</>, align: "left", width: 80, render : (e, f) => {
            return(f?.header?.invoice || "")
        }},
        { key: "date", title: <>Date</>, align: "left", width: 100, render : (e, f) =>{
            return bm_date(f?.header?.date) || "";
        }},
        { key: "customer", title: <>Customer</>, align: "left", width: 80, render : (e, f) => {
            return (f?.header.customer_ship_to?.name || "")
        }},
        { key: "title", title: <>Title</>, align: "left", grow : true, width: 80, render : (e, f) => {
            return(f?.item.title || "")
        }},
        { key: "isbn", title: <>ISBN</>, align: "left", width: 180, render : (e, f) => {
            return (f?.item?.primary_code)
        }},
        { key: "net", title: <>NET</>, align: "right", width: 80},
        { key: "discount", title: <>%%</>, align: "right", width: 20},
    ];


    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: (e) => { callback(selected) } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ARROW_DOWN, KBD.ARROW_UP, KBD.LEFT_BRACKET, KBD.TAB, KBD.SHIFT_TAB, KBD.ESCAPE, KBD.ENTER, KBD.CTRL_ENTER, KBD.PAGE_UP, KBD.PAGE_DOWN, KBD.ALT_S, KBD.ALT_H, KBD.ALT_L]);
        return cleanup;
    }, [selected]);




    return (
        <>
            <div className="shim" /><div className="shim" />
            <VirtualTable
                controller={controller}
                onRowClick={(item, event, index) => { setAlign("auto"); setSelected(item) }}
                onRowDoubleClick={(e) => callback(e)}
                next={next}
                prev={prev}
                align={align}
                onLoadMore={(_start, _end, _prepend) => {
                    if (_prepend) {
                        if (rows?.length > 0 && rows[0]?.number !== 1) {
                            // fetchPrev()
                        }
                    } else {
                        if (rows?.length > 0) {
                            setQuery(prev => ({
                                ...prev,
                                offset: prev.offset + 40
                            }));
                        }

                    }
                }}
                row_key={row_key}
                current={selected}
                data={rows}
                columns={(type === "log") ? columns : item_columns}
                width={960}
                loading={false}
                offset={830}
                route={route}
                scrollbar={true}
                scrollindicator={true}
                infinite={true}
            />
        </>
    )

}